// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl';

import { bindActionCreatorsSafe } from 'util/safeDispatch';
import { setLoggingConfig } from 'state/commands/adminPropertiesCommands';
import { getLoggingConfig } from 'state/selectors';
import LabeledField from 'view/Forms/LabeledField';
import localizedStrings from 'util/localizedStrings';
import type { Dispatch, LoggingConfig } from 'state/types';

const LOGGING_LEVELS = ['DEBUG', 'INFO', 'ERROR'];
const LOGGING_RETAIN_COUNT = [1, 2, 3, 5, 10, 15, 20, 25];
type Props = {
  intl: IntlShape,
  loggingConfig: LoggingConfig,
  onChangeLogConfig: Function,
  setLoggingConfig: typeof setLoggingConfig,
};

class LoggingControls extends Component<Props> {
  onChangeLogConfig: Function;

  constructor() {
    super();
    this.onChangeLogConfig = this.onChangeLogConfig.bind(this);
  }

  onChangeLogConfig(event, fieldName) {
    const { setLoggingConfig } = this.props;

    setLoggingConfig({
      ...this.props.loggingConfig,
      [fieldName]: event.target.value,
      logDirectory: null, // logDirectory gets set elsewhere, we don't want to mess with it.
    });
  }
  render() {
    const {
      intl: { formatMessage },
      loggingConfig,
    } = this.props;

    return (
      <div className="page page-contents-textured">
        <div className="page-header">
          <FormattedMessage {...localizedStrings.LOGGING_CONFIGURATION} />
        </div>
        <div
          className="portfolio-form-container"
          data-test-name="logging-config-page"
        >
          <div className="box">
            {/* Logging Preferences: Log Level and Number to Retain */}
            <LabeledField
              label={formatMessage(localizedStrings.LOGGING_LOG_LEVEL)}
            >
              <div className="select">
                <select
                  id="logLevel"
                  data-test-name="log-level"
                  value={loggingConfig.logLevel}
                  onChange={e => this.onChangeLogConfig(e, 'logLevel')}
                  style={{ width: '140px' }}
                >
                  {LOGGING_LEVELS.map(opt => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            </LabeledField>

            <LabeledField
              label={formatMessage(localizedStrings.LOGGING_NUM_LOGS_TO_RETAIN)}
            >
              <div className="select">
                <select
                  id="retainCount"
                  data-test-name="retain-count"
                  value={loggingConfig.retainCount}
                  onChange={e => this.onChangeLogConfig(e, 'retainCount')}
                  style={{ width: '140px' }}
                >
                  {/* if the logging retain count returned from the server is not in our array, add it */}
                  {LOGGING_RETAIN_COUNT.includes(loggingConfig.retainCount) || (
                    <option
                      key={loggingConfig.retainCount}
                      value={loggingConfig.retainCount}
                    >
                      {loggingConfig.retainCount}
                    </option>
                  )}
                  {/* now add our default options */}
                  {LOGGING_RETAIN_COUNT.map(opt => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            </LabeledField>
          </div>
        </div>
      </div>
    );
  }
}

let wrappedForm = injectIntl(LoggingControls);

export default (wrappedForm = connect(
  state => ({
    loggingConfig: getLoggingConfig(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({
      getLoggingConfig,
      setLoggingConfig,
    })
)(wrappedForm));



// WEBPACK FOOTER //
// ./src/view/Pages/StatusPage/LoggingControls.js